module.exports = __webpack_public_path__ + "static/media/group_guide_img_1_m.5ef8ff35.png";